<template>
<div class="mdl-grid">
  <div class="mdl-cell mdl-cell--12-col">
    <logo style="text-align: center"></logo>
  </div>
  <form @submit.prevent="submit" class="mdl-cell mdl-cell--12-col-phone mdl-cell--6-col-tablet" style="margin: 0 auto">
    <mdl-textfield label="Login" v-model="email" autofocus class="mdl-cell mdl-cell--12-col"></mdl-textfield>
    <mdl-textfield label="Hasło" v-model="password" class="mdl-cell mdl-cell--12-col" type="password"></mdl-textfield>
    <mdl-button primary :disabled="logging" class="mdl-cell mdl-cell--12-col">
      <template v-if="logging">Logowanie...</template>
      <template v-else>Zaloguj</template>
    </mdl-button>
  </form>
</div>
</template>

<script>
import CenterHeader from './CenterHeader.vue'
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import auth from './../auth'
import Logo from './Logo.vue'
import { MdlTextfield, MdlButton } from 'vue-mdl'

export default {
  data () {
    return {
      logging: false,
      email: '',
      password: '',
      error: ''
    }
  },
  components: {
    CenterHeader,
    FormGroup,
    TextInput,
    Logo,
    MdlTextfield,
    MdlButton
  },
  methods: {
    submit () {
      this.logging = true
      auth
        .login(this.email, this.password)
        .then(this.loginSuccess, this.loginError)
        .then(() => {
          this.logging = false
        })
    },
    loginSuccess () {
      window.location.reload()
    },
    loginError (message) {
      this.$root.$emit('flash', { message })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?309cb73c